import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    id: null,
    keyword: '',
    page: 1,
    limit: 10,
    orderBy: 'assetid',
    sortOrder: 'desc', // desc, asc
    matchType: 'all', // all, any
    filters: [],
    resultCriteria: [],
    createdPeriod: {
        enabled: false,
        type: 'hours', // [hours, days, weeks, months]
        value: null,
    },
    createdFilter: {
        enabled: false,
        type: 'before', // ["within", "before", "after"]
        value: null, // format: yyyy-mm-dd hh:mm
    },
    smartSearchId: null,
};

const searchProvider = createSlice({
    name: '@@searchProvider',
    initialState,
    reducers: {
        setQuery: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        resetQuery: state => {
            state.filters = initialState.filters;
            state.keyword = initialState.keyword;
            state.id = initialState.id;
            state.createdPeriod = initialState.createdPeriod;
            state.createdFilter = initialState.createdFilter;
            state.resultCriteria = [];
            state.smartSearchId = null;

            return state;
        },
    },
});

export default searchProvider;
